<mat-card [ngClass]="{ 'sign-flow-anonymous-popup': isDialog, 'sign-flow-anonymous': !isDialog }">
    <mat-card-content class="mat-card-content-contract-sm bg-white p-3">
        <mat-accordion #accordion="matAccordion" [multi]="true">
        <div id="sign-flow-document-v2" class="css-container">
          <div class="row">
            <div class ="col-lg-6"
                  class="col-md-12 col-sm-12 pr-0">
              <div #focus tabindex="-1" class="pr-4 css-info-sign">
                  <!-- Select sign method -->
                  <div style="border-color: #F2F2F2;"
                      class="d-flex justify-content-between align-items-center pb-2 border-bottom">
                      <div class="text-title">{{ 'two_authen.sign_method' | translate }}
                      </div>
                  </div>
                  <div class="ds-cts">
                    <div class="row">
                      <div class="col-lg-4 col-sm-6 mt-3">
                        <div>
                          <mat-form-field>
                            <mat-label>{{'digital_certificate_management.lbl_provider_cloudca' | translate}}</mat-label>
                            <mat-select #providerSelect id="providerSelect"
                              [(ngModel)]="providerName"
                              #provider="ngModel" required name="providerSelect">
                              <mat-option *ngFor="let item of lstCloudCaProvider" [value]="item.name"
                                (click)="this.commonService.closeDropdownList(this.providerSelect)">
                                {{item.name}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
  
                      <div class="col-lg-4 col-sm-6 mt-3">
                        <mat-form-field class="w-100">
                          <input matInput type="text"
                            placeholder="{{'digital_certificate_management.lbl_account_cloudca' | translate}}"
                            (focusout)="cloudCaUsername = cloudCaUsername?.trim()" [(ngModel)]="cloudCaUsername"
                            name="cloudCaUsername" #cloudCaUserId="ngModel" [ngClass]="{ 'is-invalid': cloudCaUserId.invalid }"
                            maxlength="200" required
                            (keydown.enter)="getCertificateCloudCa()"
                            >
                          <button mat-button *ngIf="cloudCaUsername" type="button" matSuffix mat-icon-button aria-label="Clear"
                            (click)="cloudCaUsername=''">
                            <mat-icon>close</mat-icon>
                          </button>
                          <mat-error *ngIf="cloudCaUserId.invalid">
                            <span class="text-error" *ngIf="cloudCaUserId?.errors?.required">
                              {{'validation.account_cloudca_required' | translate}}
                            </span>
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-lg-4 col-sm-6 d-flex justify-content-start align-items-center mb-2"
                      >
                        <button mat-raised-button type="button" [disabled]="!cloudCaUsername || !providerName "
                          (click)="getCertificateCloudCa()" color="primary">
                          <mat-icon class="mr-0">list</mat-icon>
                          {{'button.get_list' | translate}}
                        </button>
                      </div>
                    </div>
                    <!--danh sách CTS-->
                    <div class="col-12" style="padding-left: 0; padding-right: 0;"
                    >
                      <nz-table [nzData]="cloudCaDataSource" #dynamicTable2 nzShowPagination="false" nzBordered="true" [nzScroll]="{ x: '900px'}">
                        <thead>
                          <tr>
                            <th></th>
                            <th class="font-weight-bold" style=" max-width: 5%; width: 5%;">{{'two_authen.table.no' | translate}}</th>
                            <th class="font-weight-bold" style=" max-width: 20%; width: 20%;">{{'two_authen.table.name' | translate}}</th>
                            <th class="font-weight-bold" style=" max-width: 30%; width: 30%;">{{'two_authen.table.serial_number' | translate}}</th>
                            <th class="font-weight-bold" style=" max-width: 10%; width: 10%;">{{'two_authen.table.tax_code' | translate}}</th>
                            <th class="font-weight-bold" style=" max-width: 10%; width: 10%;">{{'two_authen.table.account' | translate}}</th>
                            <th class="font-weight-bold" style=" max-width: 10%; width: 10%;">{{'two_authen.table.effective_date' | translate}}</th>
                            <th class="font-weight-bold" style=" max-width: 10%; width: 10%;">{{'two_authen.table.expired_date' | translate}}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-template ngFor let-data [ngForOf]="dynamicTable2.data">
                            <tr>
                              <td nzShowCheckbox [(nzChecked)]="data.checked" (nzCheckedChange)="onSelectedCloudCaCert($event,data)">
                              </td>
                              <td style=" max-width: 5%; width: 5%;">{{data.STT}}</td>
                              <td style=" max-width: 20%; width: 20%;">{{data.certificateName}}</td>
                              <td style=" max-width: 30%; width: 30%;">{{data.serialNumber}}</td>
                              <td>{{data.taxCode}}</td>
                              <td>{{data.cloudCaUserId}}</td>
                              <td>{{data.activeDate | dateformat}}</td>
                              <td>{{data.expireDate | dateformat}}</td>
                            </tr>
                          </ng-template>
                        </tbody>
                      </nz-table>
                      <div class="pagination-text w-100 text-center" *ngIf="cloudCaDataSource.length === 0">
                        {{'form.no_record' | translate}}
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
          <span class="note">{{ "two_authen.table.note" | translate }}</span>
          <div class="button-container">
              <button id="btn-cancel" mat-stroked-button color="primary" style="margin-right: 16px !important;" type="button"
                  (click)="backToPrePage()">
                  <mat-icon class="mr-0">cancel</mat-icon>
                  {{ "button.cancel" | translate }}
              </button>
  
              <button mat-raised-button color="primary" class="mr-3" [disabled]="!selectedCert" (click)="onConfirmData()"
              >
                  <mat-icon class="mr-0">done</mat-icon>
                  {{ "two_authen.table.confirm_info" | translate }}
              </button>
          </div>
        </div>
        </mat-accordion>
    </mat-card-content>
    <ng-container *ngIf="isDialog">
      <button type="button" class="close" aria-label="Close" (click)="backToPrePage()" style="position: absolute; top: 0; right: 0;">
        <span aria-hidden="true" style="font-size: 30px;">&times;</span>
      </button>
    </ng-container>
</mat-card>